export const excludeEditData = [
  'id',
  'school_id',
  'user_id',
  'category_others',
  'created_at',
  'updated_at',
  'deleted_at',
  'photo',
  'contacts',
  'user',
]

export function makeContactData (contacts) {
  const contact = contacts[0]
  return {
    'contact[address]': contact.address,
    'contact[city]': contact.city,
    'contact[district]': contact.district,
    'contact[landmark]': contact.landmark,
    'contact[pincode]': contact.pincode,
    'contact[state]': contact.state,
    'contact[country]': contact.country,
    // 'contact[is_primary]': contact.is_primary,
    'contact[country_code]': contact.country_code,
    'contact[phone]': contact.phone,
    'contact[alt_country_code]': contact.alt_country_code,
    'contact[alt_phone]': contact.alt_phone,
    'contact[email]': contact.email,
  }
}
